module.exports = __webpack_public_path__ + "img/match_logo_football.e79802ab.png";